import { Component, type ReactNode } from 'react';

/** Keep lazy download/render failures local to the board; recovery owns the same camera and preferences. */
export class BoardErrorBoundary extends Component<{ children: ReactNode; onFailure(): void }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch() { this.props.onFailure(); }
  render() { return this.state.failed ? null : this.props.children; }
}
